import { colors } from "@mui/material";

export const products = [
    {
        id: '1',
        name: 'yearly',
        title: 'Plus Annual',
        description: 'Access all courses, career paths, assessments, jobs, and more for a year.',
        color: '#faa61a',
    },
    {
        id: '2',
        name: 'monthly',
        title: 'Plus Monthly',
        description: '',
        color: '#faa61a',
    },
    {
        id: '3',
        name: 'pro_yearly',
        title: 'Pro Annual',
        description: 'Everything in Plus Annual + monthly career coaching sessions with pharma experts.',
        color: '#18BBA8',
    },
    {
        id: '4',
        name: 'pro_monthly',
        title: 'Pro Monthly',
        description: 'Everything in Plus Monthly + monthly career coaching sessions with pharma experts.',
        color: '#18BBA8',
    },
]